export const IAM_DURATION_INTERACTION = 900;
export const IAM_DURATION_PROCESS = 2100;
export const IAM_SESSION_TIMEOUT_ALERT_DURATION = 300;

export const IAM_SESSION_DURATION = 600;

export const getAccessDeniedLocation = () => {
	return "/access-denied";
};